var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSsh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 80,
    viewBox: "0 0 216 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 16v57a4 4 0 0 0 4 4h89a4 4 0 0 0 4-4V16h26c3.866 0 7 3.582 7 8s-3.134 8-7 8h22c3.866 0 7 3.582 7 8s-3.134 8-7 8h-19c-3.866 0-7 3.582-7 8s3.134 8 7 8h6c3.866 0 7 3.582 7 8s-3.134 8-7 8h-52a6.186 6.186 0 0 1-1.5-.184c-.483.12-.985.184-1.5.184H46c-3.866 0-7-3.582-7-8s3.134-8 7-8H7c-3.866 0-7-3.582-7-8s3.134-8 7-8h40c3.866 0 7-3.582 7-8s-3.134-8-7-8H22c-3.866 0-7-3.582-7-8s3.134-8 7-8h38Zm0-.331c-2.891-.984-5-4.045-5-7.669 0-4.418 3.134-8 7-8h57c3.866 0 7 3.582 7 8a9.1 9.1 0 0 1-.22 2H64a4 4 0 0 0-4 4v1.669Z",
    fillOpacity: 0.3,
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fillOpacity: 0.3,
    fill: "#7F7F7F",
    cx: 209,
    cy: 72,
    rx: 7,
    ry: 8
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#6A6666",
    strokeWidth: 2.5,
    x: 61.25,
    y: 11.25,
    width: 94.5,
    height: 64.5,
    rx: 4
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "NotoSans-Bold, Noto Sans",
    fontSize: 17,
    fontWeight: "bold",
    letterSpacing: 1.7,
    fill: "#6A6666",
    transform: "translate(78 40)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 26,
    y: 18
  }, "SSH")), /*#__PURE__*/React.createElement("path", {
    d: "M101 52.625H90.88M86 48l-8 4.813M145.828 20h-67.71 73.172-73.172 75.905-8.195Zm-72.71 0H62h11.119ZM78.236 43 86 47.773",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSsh);
export default __webpack_public_path__ + "static/media/ssh.e08190d15b9839662659eb5310c4b96a.svg";
export { ForwardRef as ReactComponent };